import { LeaveRequestSource } from '../LeaveRequestSource.enum'

function getLabel(val: LeaveRequestSource) {
  switch (val) {
    case LeaveRequestSource.INDO:
      return 'Indo'
    case LeaveRequestSource.JAPAN:
      return 'Japan'
    default:
      return '-'
  }
}

const LeaveRequestSourceEnumHelper = {
  getLabel,
}

export default LeaveRequestSourceEnumHelper
